import React from 'react';
import { useAppContext } from 'src/components/app-context';
import { TitleMediumText } from '@prisjakt/ui/text/variants';
import { ColorVariantSelectionButton } from './color-variant-selection-button';
import { IVariantsProps } from '../types';
import {
  VariantGridWrapper,
  VariantGridTitle,
  VariantGridCell,
  VariantGridHeader,
} from '../styles';

export const ColorVariantsGrid: React.FC<IVariantsProps> = props => {
  const { title, variants, handleSelection } = props;
  const { t } = useAppContext();
  const sortedVariants = variants?.colors.filter(Boolean);

  return (
    <div>
      {title && (
        <VariantGridHeader>
          <VariantGridTitle>
            <TitleMediumText>{title}</TitleMediumText>
          </VariantGridTitle>
        </VariantGridHeader>
      )}
      <VariantGridWrapper>
        <VariantGridCell>
          <ColorVariantSelectionButton
            handleSelection={handleSelection}
            title={t('product', 'variants.all')}
            variant={null}
          />
        </VariantGridCell>
        {sortedVariants?.map(variant => (
          <VariantGridCell key={variant.color}>
            <ColorVariantSelectionButton
              handleSelection={handleSelection}
              title={variant.color!}
              variant={variant.color!}
              disabled={variant.disabled}
            />
          </VariantGridCell>
        ))}
      </VariantGridWrapper>
    </div>
  );
};
